import { render, staticRenderFns } from "./dangerousGoodsListTable.vue?vue&type=template&id=4e454756"
import script from "./dangerousGoodsListTable.vue?vue&type=script&lang=js"
export * from "./dangerousGoodsListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports